export * from './styled'
export { default } from './styled'



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/styled/index.ts